// noticeBanner.jsx
import React, { useState } from "react";
import styled from "@emotion/styled";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { mobileWidth } from "./constants";
import { useTranslation } from "react-i18next";

const DISMISS_KEY = "ratib_notice_dismissed";

// Flip to `true` once the database is confirmed to be accepting new
// submissions again, to show the "Add your salary" call-to-action.
const SHOW_CTA = false;

const NoticeBanner = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "true",
  );

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <Wrapper>
      <Alert severity="warning" onClose={dismiss}>
        <AlertTitle>{t("notice_title")}</AlertTitle>
        {t("notice_body")}
        {SHOW_CTA && (
          <div>
            <Cta onClick={() => (window.location.href = "/addsalary")}>
              {t("notice_cta")}
            </Cta>
          </div>
        )}
      </Alert>
    </Wrapper>
  );
};

export default NoticeBanner;

// Fixed overlay pinned just below the fixed navbar (100px tall), so the
// notice floats over the page content instead of taking layout space.
const Wrapper = styled.div`
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  padding: 0 20px;
  box-sizing: border-box;
  & .MuiAlert-root {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  }
  /* Let the message fill the row so the close button is pushed to the box
     edge in both LTR and RTL (MUI's margin-left:auto doesn't flip for RTL
     without an rtl style cache). */
  & .MuiAlert-message {
    flex: 1;
  }
  @media (max-width: ${mobileWidth}) {
    top: 100px;
    padding: 0 12px;
  }
`;

const Cta = styled.button`
  margin-top: 8px;
  border: none;
  background: none;
  padding: 0;
  color: inherit;
  font-weight: 700;
  font-size: inherit;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
